import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { ToastProvider } from './components/Toast';
import { ThemeProvider } from './context/ThemeContext';
import RequireAuth from './components/RequireAuth';
import { ROLES } from './constants';

import HomePage from './pages/HomePage';
import Login from './pages/Login';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import AdminSalonDashboard from './pages/AdminSalonDashboard';
import EmployeeDashboard from './pages/EmployeeDashboard';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import SuspendedAccount from './components/SuspendedAccount';
import BookingPage from './pages/BookingPage';
import BookingCancelPage from './pages/BookingCancelPage';
import ShopPage from './pages/ShopPage';
import KioskPage from './pages/KioskPage';
import RappelConfirmPage from './pages/RappelConfirmPage';
import AvisPage from './pages/AvisPage';
import AvisSalonPage from './pages/AvisSalonPage';
import SalonLandingPage from './pages/SalonLandingPage';
import InscriptionPage from './pages/InscriptionPage';
import VerifyRegistrationPage from './pages/VerifyRegistrationPage';

function App() {
  return (
    <ThemeProvider>
    <ToastProvider>
      <Router>
        <Routes>
          {/* Accueil : landing produit */}
          <Route path="/" element={<HomePage />} />

          {/* Pages publiques */}
          <Route path="/login"                          element={<Login />} />
          <Route path="/suspended"                      element={<SuspendedAccount />} />
          <Route path="/inscription"                    element={<InscriptionPage />} />
          <Route path="/verify-registration/:token"     element={<VerifyRegistrationPage />} />
          <Route path="/forgot-password"                element={<ForgotPassword />} />
          <Route path="/reset-password/:token"          element={<ResetPassword />} />

          {/* Dashboard SuperAdmin - rôle 0 uniquement */}
          <Route
            path="/super-admin-dashboard"
            element={
              <RequireAuth allowedRoles={[ROLES.SUPER_ADMIN]}>
                <SuperAdminDashboard />
              </RequireAuth>
            }
          />

          {/* Dashboard Gérant - rôle 1 uniquement */}
          <Route
            path="/dashboard"
            element={
              <RequireAuth allowedRoles={[ROLES.ADMIN]}>
                <AdminSalonDashboard />
              </RequireAuth>
            }
          />

          {/* Dashboard Employé - rôle 5 uniquement */}
          <Route
            path="/employee/dashboard"
            element={
              <RequireAuth allowedRoles={[ROLES.EMPLOYEE]}>
                <EmployeeDashboard />
              </RequireAuth>
            }
          />

          {/* Pages publiques de réservation */}
          <Route path="/s/:slug"                                element={<SalonLandingPage />} />
          <Route path="/booking/:slug"                          element={<BookingPage />} />
          <Route path="/annuler-rdv/:bookingId/:token"          element={<BookingCancelPage />} />

          {/* Boutique publique */}
          <Route path="/shop/:slug"                             element={<ShopPage />} />

          {/* Confirmation rappel client — public */}
          <Route path="/rappel/confirmer/:token"                element={<RappelConfirmPage />} />
          <Route path="/avis/salon/:slug"                      element={<AvisSalonPage />} />
          <Route path="/avis/:token"                           element={<AvisPage />} />

          {/* Borne de pointage — admin uniquement */}
          <Route
            path="/kiosk"
            element={
              <RequireAuth allowedRoles={[ROLES.ADMIN]}>
                <KioskPage />
              </RequireAuth>
            }
          />

          {/* Fallback - toute route inconnue → login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </Router>
    </ToastProvider>
    </ThemeProvider>
  );
}

export default App;
